import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Interface/IApiResponse";

interface GenerateInvoicePDFRequest {
  booking_ref: string;
  name: string;
  trn: string;
  email: string;
  address1: string;
  address2: string;
  city: string;
  country: string;
}

// Function to request invoice
export async function requestInvoiceRMSAPI(
  bookingRef: string,
  formData: {
    companyName: string;
    trn?: string;
    address1: string;
    address2: string;
    city: string;
    countryBilling: string;
  },
  userEmail: string
): Promise<{ success: boolean; data?: any; error?: any }> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = `${ENDPOINTS.requestInvoiceRMS}`;

  const requestBody: GenerateInvoicePDFRequest = {
    booking_ref: bookingRef,
    name: formData.companyName,
    trn: formData.trn || "",
    email: userEmail,
    address1: formData.address1,
    address2: formData.address2,
    city: formData.city,
    country: formData.countryBilling
  };

  try {
    const response: IApiResponse<any> = await apiRequest<any>(
      endpoint,
      'POST',
      { body: JSON.stringify(requestBody) },
      'none',
      undefined,
      undefined,
      false,
      false
    );

    const data = response.answer;
    if (data?.result?.status === "ok") {
      return { success: true, data };
    } else {
      return { success: false, error: data };
    }
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : "" };
  }
}
